import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const fetchSponseredTeamsThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getsponsorteam, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchProductTeamsThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getTeamTreeDetails)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchPendingTeamMembersThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.getPendingTeamMembers)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const fetchPendingLevelDetailsThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getPendingLevelDetails)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}

export const addTeamMemberThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addTeamMember, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
